export default __webpack_public_path__ + "static/media/recordLine.0b8fbb17.gif";